import type { BookingPaymentResult } from "./BookingPage";

type BookingPaymentResultPageProps = {
  travelTitle: string;
  travelDestination: string;
  result: BookingPaymentResult;
  onBackToDetails: () => void;
  onViewAllTravels: () => void;
};

export default function BookingPaymentResultPage({
  travelTitle,
  travelDestination,
  result,
  onBackToDetails,
  onViewAllTravels
}: BookingPaymentResultPageProps) {
  const isCompleted = result.paymentState === "COMPLETED";

  return (
    <section className="mx-auto w-full max-w-[920px] px-4 py-10 md:px-8 lg:px-10">
      <div className="rounded-3xl bg-white p-8 shadow-[0_18px_40px_rgba(15,23,36,0.12)]">
        <div className="flex items-start gap-4">
          <span
            className={`mt-1 inline-flex h-10 w-10 items-center justify-center rounded-full text-white ${
              isCompleted ? "bg-[#16a34a]" : "bg-[#f59e0b]"
            }`}
            aria-hidden="true"
          >
            {isCompleted ? "✓" : "!"}
          </span>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#9aa3af]">
              Payment Result
            </p>
            <h1 className="mt-2 text-2xl font-semibold text-[#111827] md:text-3xl">
              {isCompleted ? "Payment Successful" : "Payment Pending Confirmation"}
            </h1>
            <p className="mt-3 text-sm text-[#5f6b7a]">{result.message}</p>
          </div>
        </div>

        {!isCompleted && (
          <div className="mt-6 rounded-2xl border border-[#fde68a] bg-[#fffbeb] p-4 text-sm text-[#92400e]">
            We have received your payment request and are waiting for final confirmation
            from PayPal. Please do not pay again. We will update you by email soon.
          </div>
        )}

        <div className="mt-8 grid gap-3 rounded-2xl border border-[#e5e7eb] bg-[#f8fafc] p-4 text-sm text-[#1f2937] md:grid-cols-2">
          <p>
            <span className="text-[#9aa3af]">Trip:</span> {travelTitle}
          </p>
          <p>
            <span className="text-[#9aa3af]">Destination:</span> {travelDestination}
          </p>
          <p>
            <span className="text-[#9aa3af]">Order ID:</span> {result.orderId}
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={onBackToDetails}
            className="rounded-xl bg-[#0b1c2b] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#0d5be1]"
          >
            Back to trip details
          </button>
          <button
            type="button"
            onClick={onViewAllTravels}
            className="rounded-xl border border-[#d1d5db] bg-white px-5 py-3 text-sm font-semibold text-[#1f2937] transition hover:border-[#0d5be1] hover:text-[#0d5be1]"
          >
            View all travels
          </button>
        </div>
      </div>
    </section>
  );
}
